import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { ReactComponent as EsiaIcon } from "../icons/iconEsia24.svg";
import { ReactComponent as FacebookIcon } from "../icons/iconFacebook24.svg";
import { ReactComponent as GoogleIcon } from "../icons/iconGooglePlus24.svg";

const useStyles = makeStyles(theme => ({
    root: {
        width: 24,
        height: 24,
        // borderRadius: "50%",
        marginRight: theme.spacing(),
        marginBottom: theme.spacing(0.5),
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: "default"
    },
    icon: {
        width: "100%",
        height: "100%"
    }
}));

const iconsMap = {
    1: EsiaIcon,
    2: FacebookIcon,
    3: GoogleIcon
};

export const AccountBadge = props => {
    const { type, state } = props;
    const classes = useStyles();

    const IconComponent = iconsMap[type];
    if (!IconComponent) return null;

    return (
        <div className={classes.root}>
          <div className={classes.icon}>
              <IconComponent />
          </div>
        </div>
    );
};
